import { inject, injectable } from "inversify";
import { LandingServiceID } from "./symbols";
import type { ILandingSessionManager } from "@/lib/types/store";

export interface ILandingRootStore {
  session: ILandingSessionManager;
}

@injectable()
export class LandingRootStore implements ILandingRootStore {
  constructor(
    @inject(LandingServiceID.SessionStore)
    readonly session: ILandingSessionManager,
  ) {}
}

// https://github.com/inversify/InversifyJS/issues/997
Object.getPrototypeOf(LandingRootStore.prototype).constructor = Object;
